import Footer from 'components/desktop/_general/Footer/Footer';
import MainNavigationTop from 'components/desktop/_general/MainNavigationTop/MainNavigationTop';
import ErrorBoundary from 'containers/ErrorBoundary';

type IProps = {
	children: JSX.Element;
};

const ProtectedRouteContainer = ({ children }: IProps) => {
	return (
		<>
			<MainNavigationTop />
			<div id="root-child">
				<div id="main-area">
					<ErrorBoundary key={location.pathname}>
						<div id="main-container">{children}</div>
					</ErrorBoundary>
					<Footer />
				</div>
			</div>
		</>
	);
};

export default ProtectedRouteContainer;
